import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function Input({ className, ...props }) {
  return <input className={clsx('form-control', className)} {...props} />
}

Input.propTypes = {
  className: PropTypes.string,
  props: PropTypes.object
}
